import { rootApi } from '../../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['Region'],
});
export const regionApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllRegions: builder.query({
      query: () => `regions/`,
      providesTags: ['Region'],
    }),
    findRegionById: builder.query({
      query: (id) => `regions/${id}/`,
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'Region', id: result.id }] : ['Region'];
      },
    }),
    createRegion: builder.mutation({
      query: (region) => ({
        url: `regions/`,
        method: 'POST',
        body: region,
      }),
      invalidatesTags: ['Region'],
    }),
    updateRegion: builder.mutation({
      query: (region) => ({
        url: `regions/${region.id}/`,
        method: 'PATCH',
        body: region,
      }),
      invalidatesTags: ['Region'],
    }),
    deleteRegion: builder.mutation({
      query: (region) => ({
        url: `regions/${region.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Region'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllRegionsQuery,
  useFindRegionByIdQuery,
  useCreateRegionMutation,
  useUpdateRegionMutation,
  useDeleteRegionMutation,
} = regionApi;
